// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, SchemaForm, Button } from "@components";
import { getSchema } from "@utils/schema";
import uiSchema from "./__ui__/schema";

type OwnProps = $Exact<{
  tree: Object,
  department: Object,
  onSubmit: (formData: Object) => void,
  onClose: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;
export class MoveDepartmentModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  schema = () => {
    let schema = getSchema("HierarchyMoveOperationDTO");
    schema.properties.newParentId.tree = this.props.tree;
    return schema;
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onClose}>
          {this.props.t("MOVE_DEPARTMENT")} {this.props.department.data.label}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={this.schema()}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(MoveDepartmentModal);
